// extracted by mini-css-extract-plugin
export var base = "styles-module--base--c3e22";
export var show = "styles-module--show--d5213";